/* eslint-disable */
import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Box, Typography, Button } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { isIE } from "react-device-detect";
import Footer from "../../../../layouts/Footer";
import Header from "../../../../layouts/Header";
import Layout from "../../../../layouts/Layout";
import { usePasswordReset } from "../../shared/hooks/usePasswordReset";
import { resetPasswordPageConfig } from "./constants/constants";
import messages from "./constants/messages";
import { passwordResetParams } from "./constants/types";
import { styles } from "./constants/styles";
import { useLocation } from "react-router";
import { RequestStatus, CheckLifeTimeTypeLinks, useAuth, AuthError } from "../../shared";
import { PasswordField } from "../../../../shared/ui/PasswordField";
import { useUserSettings } from "../../../user/components/UserSettings/useUserSettings";
import { useEffect } from "react";
import { browserHistory } from "../../../../routes/history";
import { useCheckLifeTimeLink } from "../../shared/hooks/useCheckLifeTimeLink";

type Props = WithStyles<typeof styles>;

const RegisterPage: React.FC<Props> = (props: Props) => {
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const code = useQuery().get("code") || "";
  const userIdParam = useQuery().get("userId");
  const userId = userIdParam === null ? 0 : parseInt(userIdParam);

  const [queryParams] = React.useState<passwordResetParams>({
    code,
    userId,
  });
  const [status, passwordReset, error] = usePasswordReset();
  const { setValidNewPass, changeField, validNewPass, state: stateForm, validPass, setValidPass } = useUserSettings();
  const [statusCheckLifeTime, checkLifeTimeLink] = useCheckLifeTimeLink();
  const [isAuth, , , logout] = useAuth();

  useEffect(() => {
    const { userId } = queryParams;

    checkLifeTimeLink(userId, CheckLifeTimeTypeLinks.ResetPassword);
  }, []);

  if (isAuth) {
    logout();
  }

  const handleApply = () => {
    const { newPassword } = stateForm;

    if (validNewPass && newPassword) {
      const { code, userId } = queryParams;
      passwordReset(userId, code, newPassword);
    }
  };

  const renderRequestErrorMessage = () => {
    const message = error === AuthError.CannotReusePreviousPassword ? messages.passwordsIdentityError : messages.serverError;
    return (
      <Typography className={classes.errorTypo}>
        <FormattedMessage {...message} />
      </Typography>
    );
  };

  const handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      handleApply();
    }
  };

  const { classes } = props;
  const isPending = status === RequestStatus.Pending;
  const isStatusCheckLifeTimePending = statusCheckLifeTime === RequestStatus.Pending || statusCheckLifeTime === RequestStatus.None;

  if (isStatusCheckLifeTimePending) {
    return null;
  }

  return (
    <Layout>
      <Header />
      <div className={classes.root}>
        <Box className={classes.box}>
          <Typography className={classes.header}>
            <FormattedMessage {...messages.header} />
          </Typography>
          {resetPasswordPageConfig.map((item) => {
            return (
              <PasswordField
                variant="outlined"
                InputLabelProps={{
                  className: classes.inputLabel,
                  shrink: isIE ? true : undefined,
                }}
                className={classes.textField}
                value={stateForm[item.id as "newPassword" | "confirmPassword"]}
                onChange={({ target }) => changeField(item.id, target.value)}
                mode={item.id as any}
                onPasswordInvalid={item.id === "confirmPassword" ? () => setValidNewPass(false) : () => setValidPass(false)}
                onPasswordValid={item.id === "confirmPassword" ? () => setValidNewPass(true) : () => setValidPass(true)}
                newPassword={(item.id === "confirmPassword" && stateForm["newPassword"]) || undefined}
                confirmPassword={(item.id === "newPassword" && stateForm["confirmPassword"]) || undefined}
                customLabel={(item.id === "newPassword" && messages.newPassword) || undefined}
                onKeyPress={handleKeyPress}
              />
            );
          })}
          <div className={classes.buttonBase}>
            <Button
              className={classes.changeButton}
              variant="contained"
              color="primary"
              onClick={handleApply}
              disabled={isPending || !validNewPass || !validPass}
            >
              <FormattedMessage {...messages.changeButton} />
            </Button>
          </div>
          {status === RequestStatus.Fail && renderRequestErrorMessage()}
        </Box>
      </div>
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(RegisterPage);
